"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _router = _interopRequireDefault(require("@/router"));
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var _services = require("@/services");
var MutationTypes = _interopRequireWildcard(require("../mutation-types"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t11 in e) "default" !== _t11 && {}.hasOwnProperty.call(e, _t11) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t11)) && (i.get || i.set) ? o(f, _t11, i) : f[_t11] = e[_t11]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  identifiers: {
    data: [],
    total: 0
  }
};
var mutations = _defineProperty({}, MutationTypes.SET_IDENTIFIERS, function (state, _ref) {
  var payload = _ref.payload;
  state.identifiers = payload;
});
var getters = {
  identifiersList: function identifiersList(state) {
    return state.identifiers;
  }
};
var actions = {
  // Action generate QRCode
  createQRCode: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref2, _ref3) {
      var commit, rootState, payload, params, _yield$identifierServ, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref2.commit, rootState = _ref2.rootState;
            payload = _ref3.payload, params = _ref3.params;
            _context.p = 1;
            payload.farmId = rootState.farm.farm.id;
            _context.n = 2;
            return _services.identifierService.generateQrCode(payload, params);
          case 2:
            _yield$identifierServ = _context.v;
            data = _yield$identifierServ.data;
            commit(MutationTypes.SET_IDENTIFIERS, {
              payload: data
            });
            return _context.a(2, data);
          case 3:
            _context.p = 3;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }()),
  // eslint-disable-no-trailing-spaces
  fetchAllIdentifiers: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref5, page) {
      var commit, rootState, farmID, _yield$identifierServ2, data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref5.commit, rootState = _ref5.rootState;
            _context2.p = 1;
            farmID = rootState.farm.farm.id;
            _context2.n = 2;
            return _services.identifierService.fetchAll(farmID, page);
          case 2:
            _yield$identifierServ2 = _context2.v;
            data = _yield$identifierServ2.data;
            commit(MutationTypes.SET_IDENTIFIERS, {
              payload: data
            });
            return _context2.a(2, data);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }()),
  fetchIdentifiersAssociated: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref7, filter) {
      var commit, rootState, _yield$identifierServ3, data, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref7.commit, rootState = _ref7.rootState;
            _context3.p = 1;
            _context3.n = 2;
            return _services.identifierService.fetchIdentifiersAssociated(filter.associatedId, filter.page - 1);
          case 2:
            _yield$identifierServ3 = _context3.v;
            data = _yield$identifierServ3.data;
            commit(MutationTypes.SET_IDENTIFIERS, {
              payload: data
            });
            return _context3.a(2, data);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x5, _x6) {
      return _ref8.apply(this, arguments);
    };
  }()),
  fetchIdentifiersFamily: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref9, filter) {
      var commit, rootState, farmID, _yield$identifierServ4, data, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref9.commit, rootState = _ref9.rootState;
            _context4.p = 1;
            farmID = rootState.farm.farm.id;
            _context4.n = 2;
            return _services.identifierService.getTagFamily(filter.associatedId, filter.page - 1, filter.type, farmID);
          case 2:
            _yield$identifierServ4 = _context4.v;
            data = _yield$identifierServ4.data;
            commit(MutationTypes.SET_IDENTIFIERS, {
              payload: data
            });
            return _context4.a(2, data);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref0.apply(this, arguments);
    };
  }()),
  createIdentifiers: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref1, payload) {
      var commit, rootState, farmID, _yield$identifierServ5, data, blob, url, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref1.commit, rootState = _ref1.rootState;
            _context5.p = 1;
            farmID = rootState.farm.farm.id;
            _context5.n = 2;
            return _services.identifierService.printTags(payload, farmID);
          case 2:
            _yield$identifierServ5 = _context5.v;
            data = _yield$identifierServ5.data;
            blob = new Blob([data], {
              type: 'application/pdf'
            });
            url = URL.createObjectURL(blob);
            window.open(url).print();
            _context5.n = 4;
            break;
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            return _context5.a(2, Promise.reject(_t5));
          case 4:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x9, _x0) {
      return _ref10.apply(this, arguments);
    };
  }()),
  downloadTags: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref11, payload) {
      var commit, rootState, _yield$identifierServ6, data, blob, url, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref11.commit, rootState = _ref11.rootState;
            _context6.p = 1;
            _context6.n = 2;
            return _services.identifierService.downloadZip(payload);
          case 2:
            _yield$identifierServ6 = _context6.v;
            data = _yield$identifierServ6.data;
            blob = new Blob([data], {
              type: 'application/zip'
            });
            url = URL.createObjectURL(blob);
            window.open(url);
            _context6.n = 4;
            break;
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            return _context6.a(2, Promise.reject(_t6));
          case 4:
            return _context6.a(2);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref12.apply(this, arguments);
    };
  }()),
  downloadTracker: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref13, batchId) {
      var commit, rootState, _yield$identifierServ7, data, blob, url, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref13.commit, rootState = _ref13.rootState;
            _context7.p = 1;
            _context7.n = 2;
            return _services.identifierService.downloadTracker(batchId);
          case 2:
            _yield$identifierServ7 = _context7.v;
            data = _yield$identifierServ7.data;
            blob = new Blob([data], {
              type: 'image/jpg'
            });
            url = URL.createObjectURL(blob);
            window.open(url);
            _context7.n = 4;
            break;
          case 3:
            _context7.p = 3;
            _t7 = _context7.v;
            return _context7.a(2, Promise.reject(_t7));
          case 4:
            return _context7.a(2);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x11, _x12) {
      return _ref14.apply(this, arguments);
    };
  }()),
  getImageTracker: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref15, batchId) {
      var commit, rootState, _yield$identifierServ8, data, _t8;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref15.commit, rootState = _ref15.rootState;
            _context8.p = 1;
            _context8.n = 2;
            return _services.identifierService.downloadTracker(batchId);
          case 2:
            _yield$identifierServ8 = _context8.v;
            data = _yield$identifierServ8.data;
            return _context8.a(2, data);
          case 3:
            _context8.p = 3;
            _t8 = _context8.v;
            return _context8.a(2, Promise.reject(_t8));
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function (_x13, _x14) {
      return _ref16.apply(this, arguments);
    };
  }()),
  downloadTagsIdentifiers: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref17, payload) {
      var commit, rootState, _yield$identifierServ9, data, blob, url, successMessage, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref17.commit, rootState = _ref17.rootState;
            _context9.p = 1;
            _context9.n = 2;
            return _services.identifierService.downloadZipIdentifiers(payload, rootState.farm.farm.id);
          case 2:
            _yield$identifierServ9 = _context9.v;
            data = _yield$identifierServ9.data;
            console.log('data: ', data);
            if (data.type === 'application/zip') {
              blob = new Blob([data], {
                type: 'application/zip'
              });
              url = URL.createObjectURL(blob);
              window.open(url);
            } else {
              successMessage = _router.default.app.$t('message_creating_download_file');
              _helpers.messageHelper.success(successMessage);
            }
            return _context9.a(2, true);
          case 3:
            _context9.p = 3;
            _t9 = _context9.v;
            return _context9.a(2, Promise.reject(_t9));
        }
      }, _callee9, null, [[1, 3]]);
    }));
    return function (_x15, _x16) {
      return _ref18.apply(this, arguments);
    };
  }()),
  generateIdentifiers: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(_ref19, param) {
      var commit, rootState, farmID, successMessage, _t0;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            commit = _ref19.commit, rootState = _ref19.rootState;
            _context0.p = 1;
            farmID = rootState.farm.farm.id;
            _context0.n = 2;
            return _services.identifierService.generate(farmID, param);
          case 2:
            successMessage = _router.default.app.$t('pages.identifiers.messages.create_success');
            _helpers.messageHelper.success(successMessage);
            return _context0.a(2, true);
          case 3:
            _context0.p = 3;
            _t0 = _context0.v;
            _helpers.errorResponseHelper.display(_t0);
            return _context0.a(2, false);
        }
      }, _callee0, null, [[1, 3]]);
    }));
    return function (_x17, _x18) {
      return _ref20.apply(this, arguments);
    };
  }()),
  fetchDownloadReportsTags: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(_ref21) {
      var commit, rootState, farmID, _yield$identifierServ0, data, _t1;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            commit = _ref21.commit, rootState = _ref21.rootState;
            _context1.p = 1;
            farmID = rootState.farm.farm.id;
            _context1.n = 2;
            return _services.identifierService.fetchDownloadReportsTags(farmID);
          case 2:
            _yield$identifierServ0 = _context1.v;
            data = _yield$identifierServ0.data;
            return _context1.a(2, data);
          case 3:
            _context1.p = 3;
            _t1 = _context1.v;
            _helpers.errorResponseHelper.display(_t1);
            return _context1.a(2, false);
        }
      }, _callee1, null, [[1, 3]]);
    }));
    return function (_x19) {
      return _ref22.apply(this, arguments);
    };
  }()),
  generateUserIdentificationTag: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(_ref23, _ref24) {
      var rootState, userId, farmID, response, _t10;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            rootState = _ref23.rootState;
            userId = _ref24.userId;
            _context10.p = 1;
            farmID = rootState.farm.farm.id;
            _context10.n = 2;
            return _services.identifierService.generateUserIdentificationTag(farmID, userId);
          case 2:
            response = _context10.v;
            return _context10.a(2, response);
          case 3:
            _context10.p = 3;
            _t10 = _context10.v;
            _helpers.errorResponseHelper.display(_t10);
            return _context10.a(2, Promise.reject(_t10));
        }
      }, _callee10, null, [[1, 3]]);
    }));
    return function (_x20, _x21) {
      return _ref25.apply(this, arguments);
    };
  }())
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};